export default __webpack_public_path__ + "ubisoft-playtest-profile-mobile-steps-3-4.webp";